import Swal from "sweetalert2";

export const defaultToastSetting = {
  toast: true,
  position: "bottom",
  showConfirmButton: false,
  timer: 1500,
  timerProgressBar: true,
};

export const defaultToast = Swal.mixin(defaultToastSetting);

export const infoAlert = (title, text) => okAlert("info", title, text);

export const okAlert = (icon, title, text) => {
  Swal.fire({
    icon: icon,
    title: title,
    text: text,
    customClass: {
      confirmButton: "btn btn-primary",
    },
    buttonsStyling: false,
  });
};
